module.exports = __webpack_public_path__ + "7d088296/img/product-icon-grey.b248963c.svg";